<template>
  <!-- <img alt="logo" src="./assets/logo.jpg"> -->
  <FinancialDashboard msg="Welcome to Your financial App"/>
</template>

<script>
import FinancialDashboard from './components/FinancialDashboard.vue'

export default {
  name: 'App',
  components: {
    FinancialDashboard
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
